var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-t-xs-20 p-b-xs-20" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12" }, [
          _c(
            "div",
            { staticClass: "button__group m-b-xs-20" },
            [
              _c(
                "ak-button",
                { attrs: { size: "small" }, on: { click: _vm.backToGrid } },
                [
                  _c("i", { staticClass: "ak-icon ak-button__icon" }, [
                    _vm._v("arrow_left"),
                  ]),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("Ga naar lijst")) +
                      "\n                    "
                  ),
                ]
              ),
              _vm._v(" "),
              !_vm.data.transactionOk || _vm.data.settlement.isHandled
                ? _c(
                    "ak-button",
                    { attrs: { size: "small" }, on: { click: _vm.goToNext } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("Ga naar volgende")) +
                          "\n                        "
                      ),
                      _c("i", { staticClass: "ak-icon ak-button__icon" }, [
                        _vm._v("arrow_right"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-lg-8" },
          [
            !_vm.loading
              ? _c(
                  "div",
                  { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "ak-panel__header ak-panel__header--small",
                        class: [
                          {
                            "ak-panel__header--success": _vm.data.transactionOk,
                          },
                          {
                            "ak-panel__header--warning":
                              !_vm.data.transactionOk,
                          },
                        ],
                      },
                      [
                        _c("div", { staticClass: "ak-panel__title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("Terugbetaling Mollie")) +
                              " "
                          ),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm._f("date-relative")(
                                  _vm.data.settlement.settledAt
                                )
                              )
                            ),
                          ]),
                          _vm._v(" ("),
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "https://www.mollie.com/dashboard/org_7791761/administration/settlements/" +
                                  _vm.data.settlement.mollieId,
                                target: "_blank",
                              },
                            },
                            [_vm._v(_vm._s(_vm.data.settlement.mollieId))]
                          ),
                          _vm._v(")\n                        "),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "ak-panel__body ak-panel__body--small reading",
                      },
                      [
                        true || _vm.data.transactionOk
                          ? _c(
                              "div",
                              [
                                _c("p", [
                                  _c("i", { staticClass: "fa fa-check" }),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "Aantal Mollie betaaltransacties matcht met het aantal verkoopsfacturen in Exact Online."
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.data.settlement.dateHandled
                                  ? _c("p", [
                                      _c("i", { staticClass: "fa fa-check" }),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t(
                                              "Import bevestigd op @date door @admin",
                                              {
                                                "@date":
                                                  _vm.dateHandledForDisplay,
                                                "@admin":
                                                  _vm.data.settlement.adminName,
                                              }
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("p", { staticClass: "text-muted small" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "Gesynchroniseerd vanuit Mollie:"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                  _c("i", { staticClass: "fa fa-eur" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.data.settlement.amountForAdmin
                                      ) +
                                      "\n                                "
                                  ),
                                  _c("i", { staticClass: "fa fa-credit-card" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("@amount betalingen", {
                                          "@amount":
                                            _vm.data.settlement.totalPayments,
                                        })
                                      ) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                !_vm.data.settlement.isHandled
                                  ? _c(
                                      "ak-button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.exportTransaction.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t("Download als MT940")
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.data.settlement.isHandled
                                  ? [
                                      _c("hr"),
                                      _vm._v(" "),
                                      _c("ak-checkbox", {
                                        attrs: {
                                          id: _vm.isHandled,
                                          hasError: _vm.hasError,
                                          error: _vm.$t(_vm.error),
                                          title: _vm.$t(
                                            "Is geimporteerd in Exact Online?"
                                          ),
                                        },
                                        model: {
                                          value: _vm.isHandled,
                                          callback: function ($$v) {
                                            _vm.isHandled = $$v
                                          },
                                          expression: "isHandled",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "ak-button",
                                        {
                                          attrs: { colorMode: "secondary" },
                                          on: { click: _vm.submitForm },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t("Importeren bevestigen")
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _c("div", [
                              _c("div", { staticClass: "text-muted" }, [
                                _c("i", { staticClass: "fa fa-warning" }),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "Aantal Mollie betaaltransacties komt niet overeen met het aantal verkoopsfacturen in Exact Online."
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("ak-loader", { attrs: { size: "large", loading: _vm.loading } }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-4" }, [
          _c(
            "div",
            { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
            [
              _c(
                "div",
                { staticClass: "ak-panel__header ak-panel__header--small" },
                [
                  _c("div", { staticClass: "ak-panel__title" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("Nog te verwerken terugbetaligen")) +
                        "\n                        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ak-panel__body ak-panel__body--small reading" },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.data.totalToDo) +
                      "\n                    "
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }